// Actualizar la interfaz SysI_Agenda en types.agendaCitas.ts
export interface AppointmentsState {
  ModePatient: 'new' | 'view' | 'update' | 'view' | 'loading';
  PatientData: any | null;
}

export interface SysI_Agenda {
  Ag_Id: number;
  Ag_Us_Id: number;
  Ag_Sd_Id: number;
  Ag_Nombre: string;
  Ag_Descripcion: string | null;
  Ag_Color: string;
  Ag_Estado: boolean;
  Ag_HoraInicio: string | Date | null; // Permite tanto string como Date
  Ag_HoraFin: string | Date | null; // Permite tanto string como Date
  Ag_PeriodoCita: number | null; // En minutos
}

export interface SysI_AgendaCitas {
  Ct_Id: number;
  Ct_Pa_Id: number;
  Ct_Cz_Id: number | null;
  Ct_POrd_Id: number | null;
  Ct_Ag_Id: number;
  Ct_Notas: string | null;
  Ct_FechaAtencion: Date | string;
  Ct_FechaFinAtencion: Date | string;
  Ct_FechaSolicitud: Date | string;
  Ct_Estado: number;
  Paciente: SysI_Paciente; 
  Agenda: SysI_Agenda; 
}

export interface SysI_Paciente {
  Pc_Id: number;
  Pc_Identificacion: string;
  Pc_Nombre: string;
  Pc_Apellido1: string;
  Pc_Gn_Id: number | null;
  Pc_FechaNacimiento: Date | string | null;
}

export interface SysI_AgendaCitasExtendido extends SysI_AgendaCitas {
  NombreAgenda?: string;
  NombrePaciente?: string;
  Estado?: string;
  ColorEstado?: string;
}

// Enumeraciones
export enum EstadoCita {
  Programada = 1,
  Completada = 2,
  Cancelada = 3,
  NoAsistio = 4,
}

// Interfaces para filtros
export interface FiltroAgenda {
  userId?: number;
}

export interface FiltroCitas {
  agendaId?: number;
  pacienteId?: number;
  userId?: number;
  fechaInicio?: Date | string;
  fechaFin?: Date | string;
}

// Información para agregar en el calendario
export interface EventoCalendario {
  id: number;
  title: string;
  start: Date;
  end: Date;
  backgroundColor: string;
  borderColor: string;
  textColor: string;
  extendedProps: {
    pacienteId: number;
    agendaId: number;
    notas: string | null;
    estado: number;
    nombrePaciente?: string;
  };
}

export interface AppointmentData {
  id: number;
  title: string;
  documento: string;
  startDate: Date;
  endDate: Date;
  description: string;
  status: number;
  allDay: boolean;
  color?: string;
  usuario: string;
  quotationId?: number | null;
  preorderId?: number | null;
}

export interface AppointmentFormData {
  id: number | null; // ID de la cita, null si es nueva
  agendaId: number | null;
  patientId: number | undefined;
  patientDocument: string;
  patientName: string;
  patientLastName: string;
  patientGender: number | null; // 1 = Femenino, 2 = Masculino
  patientBirthDate: Date | null; // Fecha de nacimiento
  startDate: Date;
  endDate: Date;
  notes: string;
  status: number;
  quotationId?: number | null; // ID de cotización opcional
  preorderId?: number | null; // ID de preorden opcional
  usuario: string;
}

export interface ExtendedAppointmentFormData extends AppointmentFormData {
  patientDocument: string;
  patientName: string;
  patientLastName: string;
  patientGender: number | null;
  patientBirthDate: Date | null;
}

// Mapeo de estados a colores
export const ColoresEstadoCita = {
  [EstadoCita.Programada]: '#3788d8', // Azul
  [EstadoCita.Completada]: '#28a745', // Verde oscuro
  [EstadoCita.Cancelada]: '#dc3545', // Rojo
  [EstadoCita.NoAsistio]: '#6c757d', // Gris
};

// Mapeo de estados a nombres
export const NombresEstadoCita = {
  [EstadoCita.Programada]: 'Programada',
  [EstadoCita.Completada]: 'Completada',
  [EstadoCita.Cancelada]: 'Cancelada',
  [EstadoCita.NoAsistio]: 'No Asistió',
};
